const resource = {
    resource_identifier_in_use: 'The API identifier {{indicator}} is already in use',
    cannot_delete_management_api: 'Cannot delete Logto management API.',
    cannot_modify_management_api: 'Cannot modify Logto management API.',
};
export default Object.freeze(resource);
